<section>
	<h3 lvrPadding [padHorizontal]="16" [padVertical]="24">
		<ng-content select="[title]"></ng-content>
	</h3>
	<div lvrPadding [padHorizontal]="8" [padVertical]="24">
		<ng-content select="[content]"></ng-content>
	</div>
</section>
